import React from 'react';
import classNames from 'classnames';
import styles from './SelectedRadio.module.scss';

interface SelectedRadioProps {
  active: boolean;
}

const SelectedRadio = ({ active }: SelectedRadioProps): JSX.Element => {
  return (
    <div className={classNames(styles.hlSelectedRadioCircleImage, { [styles.selected]: active })}>
      <span className={styles.hlCheck} />
    </div>
  );
};

export default SelectedRadio;
